<main class="c-main wow-consulta">
  <div class="container-fluid">
    <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">
      {{ erro }}
    </div>
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-consulta__header">
          <div class="wow-consulta__header-icon"><mat-icon>color_lens</mat-icon></div>
          <mat-card-title>Perfil</mat-card-title>
        </div>

      <app-wow-consulta-filtros
        [tipoFiltros]="tipoFiltros"
        [(tipoFiltro)]="tipoFiltro"
        [(parametro)]="parametro"
        [parametroMask]="tipoFiltro === 'ID' ? 'separator.0' : ''"
        (consultar)="consultar()"
        (novo)="novo()">
      </app-wow-consulta-filtros>

      <div class="wow-consulta__empty" *ngIf="!consultaRealizada">
        Clique em <strong>Consultar</strong> para listar os perfis cadastrados.
      </div>

      <table *ngIf="consultaRealizada" mat-table [dataSource]="perfis" class="full-width">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef> ID </th>
          <td mat-cell *matCellDef="let perfil"> {{ perfil.id }} </td>
        </ng-container>
        <ng-container matColumnDef="nome">
          <th mat-header-cell *matHeaderCellDef> Nome </th>
          <td mat-cell *matCellDef="let perfil"> {{ perfil.nome }} </td>
        </ng-container>
        <ng-container matColumnDef="descricao">
          <th mat-header-cell *matHeaderCellDef>Descrição</th>
          <td mat-cell *matCellDef="let perfil"> {{ perfil.descricao }} </td>
        </ng-container>
        <ng-container matColumnDef="ativo">
          <th mat-header-cell *matHeaderCellDef>Ativo</th>
          <td mat-cell *matCellDef="let perfil"> {{ perfil.ativo ? "Sim" : "Não" }} </td>
        </ng-container>
        <ng-container matColumnDef="editar">
          <th mat-header-cell *matHeaderCellDef>Editar</th>
          <td mat-cell *matCellDef="let perfil" (click)="$event.stopPropagation()">
            <button (click)="editar(perfil.id)" mat-icon-button color="accent">
              <mat-icon>edit</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="ordemColunasTabela"></tr>
        <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;" class="wow-consulta__row"
          (click)="editar(row.id)"></tr>
      </table>

      <mat-paginator *ngIf="consultaRealizada" [length]="totalElementos" [pageSize]="tamanho"
        [pageSizeOptions]="pageSizeOptions" (page)="paginar($event)">
      </mat-paginator>
    </mat-card>
    </div>
  </div>
</main>
